const ADMIN_TOKEN_KEY = "tna_admin_token";
const ADMIN_USER_KEY = "tna_admin_user";

export const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_USER_KEY) || "null");
  } catch {
    return null;
  }
};

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || "";

export const storeSession = ({ token, user }) => {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(user || null));
};

export const clearSession = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
};
